<template>
  <div
    class="list-button"
    :class="{ 'has-description': description }"
    @click="handleClick"
  >
    <div v-if="icon" class="icon">
      <vs-icon :icon="icon" class="icon-container material-icons-outlined" />
    </div>
    <div class="label">{{ label }}</div>
    <div v-if="description" class="description">{{ description }}</div>
  </div>
</template>

<script>
export default {
  name: "MenuCard",
  props: {
    label: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      default: null,
    },
    description: {
      type: String,
      default: null,
    },
  },
  methods: {
    handleClick() {
      this.$emit("click");
    },
  },
};
</script>

<style lang="scss" scoped>
.list-button {
  display: flex;
  width: 260px;
  padding: 8px 32px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 6px;
  border: 1px solid #039be5;
  background: #fff;
  cursor: pointer;
  transition: all 0.2s ease;

  // descriptionがある場合の上書き設定
  &.has-description {
    padding: 16px;
  }

  &:hover {
    background: rgba(3, 155, 229, 0.05);
  }

  .icon {
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;

    .icon-container {
      width: 20px;
      height: 20px;
      color: #039be5;
      font-size: 20px !important;
    }
  }

  .label {
    display: flex;
    align-items: center;
    color: #039be5;
    text-align: center;
    font-family: Inter, -apple-system, Roboto, Helvetica, sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%;
    letter-spacing: -0.176px;
  }

  .description {
    display: flex;
    align-self: flex-start;
    text-align: left;
    color: #1e1e1e;
    font-family: Inter, -apple-system, Roboto, Helvetica, sans-serif;
    font-size: 12px;
    font-weight: 400;
    line-height: 150%;
    letter-spacing: -0.176px;
  }
}
</style>
